import { eventBus } from '@ahoy/aquarium/dist/core/EventBus';
export { DEFAULT_BUS, EventBus, MessageBus, eventBus } from '@ahoy/aquarium/dist/core/EventBus';

// @ts-ignore
window.eventBus = eventBus;
